import { useEffect, useState } from 'react'
import { AxiosError } from 'axios'
import { toast } from 'react-toastify'
import { getAllActiveMembers } from '../services/dashboard.service'

const EXPORT_PAGE_SIZE = 100

// Export mengambil seluruh data yang cocok dengan filter yang sedang aktif,
// halaman demi halaman -- bukan cuma halaman yang kebetulan sedang dibuka.
//
// `onProgress` dipanggil tiap satu halaman selesai dengan { loaded, total },
// `signal` dari AbortController dipakai untuk membatalkan di tengah jalan.
//
// Catatan: `total` di level atas response /api/active-members isinya panjang
// halaman, bukan total keseluruhan. Yang benar ada di `pagination.total`.
export const fetchAllActiveMembers = async ({
  query = '',
  status = 'All',
  korwil = '',
  sortColumnn,
  sortOrder,
  onProgress,
  signal,
} = {}) => {
  const report = (loaded, total) => onProgress?.({ loaded, total })
  const params = {
    query,
    status,
    korwil,
    sortColumnn,
    sortOrder,
    pageSize: EXPORT_PAGE_SIZE,
    signal,
  }

  const first = await getAllActiveMembers({ ...params, page: 1 })
  const rows = first?.data ?? []
  const meta = first?.pagination ?? null

  if (!meta) {
    report(rows.length, rows.length)
    return rows
  }

  const total = meta.total ?? rows.length
  const pageCount = meta.pageCount ?? Math.ceil(total / EXPORT_PAGE_SIZE)
  report(rows.length, total)

  for (let page = 2; page <= pageCount; page++) {
    const next = await getAllActiveMembers({ ...params, page })
    rows.push(...(next?.data ?? []))
    report(rows.length, total)
  }
  return rows
}

export const useGetAnggotaAktif = ({
  query,
  pageSize,
  page,
  status,
  korwil,
  sortColumnn,
  sortOrder,
}) => {
  const [data, setData] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    const fetch = async () => {
      try {
        setIsLoading(true)
        const data = await getAllActiveMembers({
          query,
          pageSize,
          page,
          status,
          korwil,
          sortColumnn,
          sortOrder,
        })
        setData(data)
      } catch (error) {
        let message = "There's something error. Please try again later."
        if (error instanceof AxiosError) {
          message =
            error.response.data?.error?.message ??
            "There's something error. Please try again later."
        }
        toast.error(message, {
          toastId: message,
        })
      } finally {
        setIsLoading(false)
      }
    }
    fetch()
  }, [query, pageSize, page, status, korwil, sortColumnn, sortOrder])

  return { data, isLoading }
}
